import { MaterialGroup } from '@cutr/constants/cutlist';
import { useTranslation } from 'react-i18next';

import { useActiveGroup } from '@/api/materialsGroup';
import { useCutlistState } from '@/api/store';

import styles from './EmptyTableNudge.module.css';

export const EmptyTableNudge = ({ group }: { group: MaterialGroup }) => {
  const { t } = useTranslation();

  const parts = useCutlistState((state) =>
    state.parts.filter((part) => part.groupId === group.id)
  );
  const activeGroup = useActiveGroup();

  const isBeamGroup = activeGroup?.type === 'beams';

  if (parts.length > 0) return null;

  return (
    <div className={styles.nudgeText}>
      <h4>
        {t(`cutlist-form.nudge.${isBeamGroup ? 'noBeamParts' : 'noParts'}`)}
      </h4>
    </div>
  );
};
